import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { ApplicationEmptyState, BaasicButton, BaasicConfirmModal, BaasicConfirmModalNew, BaasicDraggableModal, GlobalSignalRListener, BaasicModal, ScrollToTopButton } from 'core/components';
import { PreviewLayout } from 'core/layouts';
import { FacilityOrderPatientNewFlowClinicalEdit } from "application/facility-order-new-flow-clinical/components";
import { toDate } from "core/utils";
import { DropDownButton, DropDownButtonItem, Button } from "@progress/kendo-react-buttons";
import { MultiSelect } from "@progress/kendo-react-dropdowns";
import moment from "moment";
import { FacilityOrderTemplateNewFlowInsuranceHistoryOfChangesModal, FacilityOrderPatientNewFlowInsuranceNoteModal } from "application/facility-order-new-flow-insurance/components";
import { FacilityOrderTemplateMissingDocumentNoteModal, FacilityOrderTemplatePNMissingInformationModal, FacilityOrderTemplateNewFlowInvoiceNoteModal } from "application/facility-order/components";
import { FacilityOrderTemplateItemNewFlowActivatePatientModal, FacilityOrderTemplateItemNewFlowCalculationModal, FacilityOrderTemplateItemNewFlowDeleteQuestionModal, FacilityOrderTemplateNewFlowDeleteModal } from "application/facility-order-new-flow/components";
import { FacilityOrderNewFlowStatusBar, FacilityOrderNewFlowUSIntakeFindAndReplaceModal, FacilityOrderTemplateNewFlowUSIntakeInsuranceQuestionModal, FacilityOrderPatientNewFlowInsuranceEditModal, FacilityOrderPatientNewFlowUSIntakeInsuranceInfoModal, CreateFacilityOrderTemplateUSIntakeNewFlowModal, FacilityOrderPatientNewFlowUSIntakeEligibilityStatusNoteModal, FacilityOrderTemplateNewFlowUSIntakePortalNoteModal, FacilityOrderTemplateDoNotSupplyModal, FacilityOrderTemplateNewFlowUSIntakeMissingProductNoteModal, FacilityOrderTemplateNewFlowUSIntakeTemplateActivationModal, FacilityOrderTemplateNewFlowUSIntakeClinicalStatusNoteModal } from "application/facility-order-new-flow-us-intake/components";
import { Tooltip as ReactTooltip } from "react-tooltip";

function FacilityOrderNewFlowClinicalPreviewTemplate({ facilityOrderNewFlowClinicalPreviewViewStore }) {
    const {
        loaderStore,
        facilityOrder,
        facilityOrderPatientStores,
        itemCategoryStore,
        itemCategories,
        tabItems,
        selectedStatusAbrv,
        setStatus,
        fetchingTemplates,
        goToFacilityPreview,
        goToFacilityCalendar,
        downloadFacilityOrder,
        downloadFacilityOrderCsv,
        filterByCategory,
        facilityOrderStatus,
        startClinicalReview,
        disabled,
        isStatusBarVisible,
        changeStatusBarVisibility,
        insuranceCoverageStatusOverviewEmailEdit,
        documentationRequestCreate,
        isDisabled,
        statusConfirmModal,
        id,
        rootStore,
        signalRAction,
        usIntakeStatus,
        setClinicalReviewCompleted,
        isEmpty,
        isReviewed,
        documentationRequestConfirmModal,
        filterByQuestion,
        questionsStore,
        selectedQuestions,
        downloadInventoryReport,
        openFacilityOrderNewFlowUSIntakeFindAndReplaceModal,
        facilityOrderNewFlowUSIntakeFindAndReplaceModal,
        pickTicketHeaderStatus,
        importFacilityOrder,
        isImportAllowed,
        notification,
        importConfirmModal,
        importFacilityOrderConfirmModal,
        orderHistory,
        facilityOrderTemplateItemNewFlowCalculationModal,
        facilityOrderTemplateMissingDocumentNoteModal,
        facilityOrderTemplateNewFlowUSIntakePortalNoteModal,
        facilityOrderTemplateDoNotSupplyModal,
        facilityOrderTemplateNewFlowUSIntakeMissingProductNoteModal,
        facilityOrderTemplateItemNewFlowDeleteQuestionModal,
        facilityOrderTemplatePNMissingInformationModal,
        facilityOrderTemplateNewFlowUSIntakeClinicalStatusNoteModal,
        facilityOrderTemplateNewFlowDeleteModal,
        facilityOrderTemplateNewFlowInsuranceHistoryOfChangesModal,
        facilityOrderTemplateNewFlowUSIntakeInsuranceQuestionModal,
        facilityOrderPatientNewFlowInsuranceEditModal,
        facilityOrderPatientNewFlowUSIntakeInsuranceInfoModal,
        facilityOrderPatientNewFlowInsuranceNoteModal,
        createFacilityOrderTemplateUSIntakeNewFlowModal,
        facilityOrderTemplateItemNewFlowActivatePatientModal,
        facilityOrderPatientNewFlowUSIntakeEligibilityStatusNoteModal,
        facilityOrderTemplateNewFlowUSIntakeTemplateActivationModal,
        facilityOrderTemplateNewFlowInvoiceNoteModal,
        goToCreatePatient,
        extraSuppliesApprovalRequiredModal,
        disabledSendOrder,
        isInventoryStepAllowed,
        isDocumentationRequestSent,
        hasMissingDocuments
    } = facilityOrderNewFlowClinicalPreviewViewStore;

    const tabButtons = tabItems ? tabItems.map(item =>
        <BaasicButton key={item.abrv}
            className={"tabs__item " + (item.abrv == selectedStatusAbrv ? 'active' : '')}
            label={item.name}
            onClick={() => item.abrv != selectedStatusAbrv ? setStatus(item.abrv) : {}}
        />
    ) : null;

    const handleDropDownItemsOnClick = (e) => {
        if (e.item.text === "New Patient") {
            goToCreatePatient();
        }
        else if (e.item.text === "Overview Email") {
            insuranceCoverageStatusOverviewEmailEdit();
        }
        else if (e.item.text === "Documentation Request") {
            documentationRequestCreate();
        }
        else if (e.item.text === "Inventory Report") {
            downloadInventoryReport();
        }
        else if (e.item.text === "Find and Replace") {
            openFacilityOrderNewFlowUSIntakeFindAndReplaceModal();
        }
        else if (e.item.text === "Import to Brightree") {
            importFacilityOrder();
        }
        else if (e.item.text === "Export FO CSV") {
            downloadFacilityOrderCsv();
        }
    }

    return (
        <PreviewLayout className="container container--new-flow" store={facilityOrderNewFlowClinicalPreviewViewStore} emptyRenderer={<ApplicationEmptyState />} layoutFooterVisible={false} loading={loaderStore.loading || fetchingTemplates}>
            <GlobalSignalRListener groupId={id} rootStore={rootStore} action={signalRAction} />
            {notification &&
                <div className='message__bar'>
                    <span>{notification} </span><a href="#" onClick={() => window.location.reload()} title="Reload Page" className='message__bar__btn'>Reload</a>
                </div>
            }
            {((pickTicketHeaderStatus && pickTicketHeaderStatus != "new") || (facilityOrder && facilityOrder.sendOrder)) &&
                <div className='purches-notification' style={notification && { marginTop: "28px" }}>
                    <div className='message__bar purches-notification-row' style={notification && { marginTop: "27px" }}>
                        <span>{pickTicketHeaderStatus === "in-progress" ? "Purchasing is in progress. Don't make changes to the facility order." : pickTicketHeaderStatus === "completed" ? "Purchasing is complete. Don't make changes to the facility order." : "Billing is in Progress, any changes made must be reported to the biller."}</span>
                    </div>
                </div>
            }
            <FacilityOrderNewFlowStatusBar facilityOrder={facilityOrder} title={facilityOrder && `${facilityOrder.facility.name} - DOS ${toDate(facilityOrder.dateOfService)}`} isOpen={isStatusBarVisible} changeStatusBarVisibility={() => changeStatusBarVisibility()} isInventoryStepAllowed={isInventoryStepAllowed}>
                <div className="content__header__actions">
                    <ReactTooltip positionStrategy="fixed" id="historyTooltip" place="bottom" />
                    <Button className="btn btn--base btn--light u-mar--right--tny" icon="u-icon u-icon--med-lrg u-icon--us-history" onClick={() => orderHistory()} data-tooltip-content="Facility Order History" data-tooltip-id="historyTooltip" />

                    <ReactTooltip positionStrategy="fixed" id="facilityPreviewTooltip" place="bottom" />
                    <a className="btn btn--base btn--light u-mar--right--tny" target='_blank' data-tooltip-content="Facility Preview" data-tooltip-id="facilityPreviewTooltip" onClick={() => goToFacilityPreview()}><i className="u-icon u-icon--sml u-icon--preview--dark"></i></a>
                    
                    <ReactTooltip positionStrategy="fixed" id="orderingTooltip" place="bottom" />
                    <a className="btn btn--base btn--light u-mar--right--tny" target='_blank' data-tooltip-content="Ordering Calendar" data-tooltip-id="orderingTooltip" onClick={() => goToFacilityCalendar()}><i className="u-icon u-icon--sml u-icon--schedules"></i></a>
                    
                    <ReactTooltip positionStrategy="fixed" id="reportTooltip" place="bottom" />
                    <a className="btn btn--base btn--light" target='_blank' data-tooltip-content="FO Report Download" data-tooltip-id="reportTooltip" onClick={() => downloadFacilityOrder()}><i className="u-icon u-icon--sml u-icon--download--brand"></i></a>
                </div>
            </FacilityOrderNewFlowStatusBar>

            <div className="u-flex--space-between">
                <div className="tabs__wrapper">
                    <div className="tabs tabs--fullwidth">
                        {tabButtons}
                    </div>
                </div>
                <div className="u-flex--default u-mar--left--auto">
                    {!isDisabled() && !(facilityOrderStatus && facilityOrderStatus.startedOn) && <BaasicButton className="btn btn--base btn--primary u-mar--right--sml" label="Start" disabled={disabledSendOrder} onClick={() => startClinicalReview()} />}
                    {selectedStatusAbrv !== "discharge" && <div className="multiselect__group is-questions u-mar--right--sml">
                        <MultiSelect
                            data={questionsStore.originalItems}
                            textField="name"
                            dataItemKey="id"
                            value={selectedQuestions}
                            filterable={false}
                            placeholder="Please select"
                            onChange={(e) => filterByQuestion(e)}
                            tags={
                                selectedQuestions.length > 0
                                    ? [
                                        {
                                            text: selectedQuestions.length == 1 ? selectedQuestions[0].name : `Multiple`,
                                            data: selectedQuestions,
                                        },
                                    ] : []
                            }
                        />
                    </div>}
                    <div className="multiselect__group is-category u-mar--right--sml">
                        <MultiSelect
                            data={itemCategoryStore.originalItems}
                            textField="name"
                            dataItemKey="id"
                            value={itemCategories}
                            filterable={false}
                            placeholder="Please select"
                            onChange={(e) => filterByCategory(e)}
                            tags={
                                itemCategories.length > 0
                                    ? [
                                        {
                                            text: itemCategories.length == 1 ? itemCategories[0].name : `Multiple`,
                                            data: itemCategories,
                                        },
                                    ] : []
                            }
                        />
                    </div>
                    <DropDownButton
                        fillMode={"solid"}
                        themeColor={"primary"}
                        text="Actions"
                        onItemClick={(e) => handleDropDownItemsOnClick(e)}
                        buttonClass="btn btn--base btn--ghost"
                        // disabled={disabled}
                        popupSettings={{
                            animate: false,
                            anchorAlign: { horizontal: "right", vertical: "bottom" },
                            popupAlign: { horizontal: "right", vertical: "top" },
                            popupClass: 'is-clean'
                        }}
                    >
                        {selectedStatusAbrv !== "discharge" && !disabledSendOrder && <DropDownButtonItem text="New Patient" iconClass="u-icon u-icon--sml u-icon--add-lined u-mar--right--tny" />}
                        <DropDownButtonItem text="Overview Email" />
                        <DropDownButtonItem text="Documentation Request" />
                        <DropDownButtonItem text="Inventory Report" />
                        {!disabledSendOrder && <DropDownButtonItem text="Find and Replace" />}
                        {isImportAllowed && <DropDownButtonItem text="Import to Brightree" />}
                        <DropDownButtonItem text="Export FO CSV" />
                    </DropDownButton>
                </div>
            </div>
            {
                isDisabled() &&
                <div className="u-mar--bottom--sml">Clinical Review cannot be started prior to US Intake starting their flow.</div>
            }
            {
                selectedStatusAbrv === "in-progress" && facilityOrderStatus && facilityOrderStatus.completedOn && <div className="u-mar--bottom--sml">Clinical review has been completed on {moment(facilityOrderStatus.completedOn).format("MM/DD/YYYY, hh:mm A")}</div>
            }
            {
                selectedStatusAbrv === "discharge" && (usIntakeStatus && usIntakeStatus.completedOn) && !(facilityOrderStatus && facilityOrderStatus.completedOn) && isReviewed && !hasMissingDocuments && !isDocumentationRequestSent &&
                <div className="empty-state--facility-orders-discharges">
                    <p className="empty-state--facility-orders-discharges--description">You have no orders in progress!</p>
                    <BaasicButton className="btn btn--base btn--primary" label="Clinical Review is Complete" disabled={disabledSendOrder} onClick={() => setClinicalReviewCompleted()} />
                </div>
            }
            {
                selectedStatusAbrv === "discharge" && (usIntakeStatus && usIntakeStatus.completedOn) && !(facilityOrderStatus && facilityOrderStatus.completedOn) && isReviewed && isDocumentationRequestSent && hasMissingDocuments &&
                <div className="empty-state--facility-orders-discharges">
                    <p className="empty-state--facility-orders-discharges--description">You have no orders in progress!</p>
                    <BaasicButton className="btn btn--base btn--primary" label="Clinical Review is Complete" disabled={disabledSendOrder} onClick={() => setClinicalReviewCompleted()} />
                </div>
            }
            {
                selectedStatusAbrv === "discharge" && (usIntakeStatus && usIntakeStatus.completedOn) && !(facilityOrderStatus && facilityOrderStatus.completedOn) && isReviewed && !isDocumentationRequestSent && hasMissingDocuments &&
                <div className="empty-state--facility-orders-discharges">
                    <p className="empty-state--facility-orders-discharges--description">You have no orders in progress!</p>
                    <BaasicButton className="btn btn--base btn--primary" label="Document Request" icon="u-icon u-icon--med u-icon--mail-send--new--invert" disabled={disabledSendOrder} onClick={() => documentationRequestCreate()} />
                </div>
            }
            {
                isEmpty ? 
                    (usIntakeStatus && usIntakeStatus.completedOn) ?
                        (isReviewed ?
                            <div className="empty-state--facility-orders">
                                <div className="empty-state--facility-orders--table"></div>
                                <p className="empty-state--facility-orders--description">You have no orders in progress!</p>

                                {((!isDocumentationRequestSent && !hasMissingDocuments) || 
                                (isDocumentationRequestSent && hasMissingDocuments) ||
                                (isDocumentationRequestSent && !hasMissingDocuments)) && (
                                    <BaasicButton
                                        className="btn btn--base btn--primary"
                                        label="Clinical Review is Complete"
                                        disabled={disabledSendOrder}
                                        onClick={() => setClinicalReviewCompleted()}
                                    />
                                )}

                                {(!isDocumentationRequestSent && hasMissingDocuments) && (
                                    <BaasicButton
                                        className="btn btn--base btn--primary"
                                        label="Document Request"
                                        icon="u-icon u-icon--med u-icon--mail-send--new--invert"
                                        disabled={disabledSendOrder}
                                        onClick={() => documentationRequestCreate()}
                                    />
                                )}
                            </div>
                            :
                            <div className="u-mar--bottom--sml">
                                All In Progress templates have been reviewed. Please review the discharged templates to complete Clinical Review.
                            </div>
                        )
                        :
                        isReviewed && (
                            <div className="u-mar--bottom--sml">
                                Clinical Review can't be completed before US Intake is completed.
                            </div>
                        )
                    :
                    (facilityOrderPatientStores && facilityOrderPatientStores.length > 0) ?
                        facilityOrderPatientStores.map(store => (
                            <FacilityOrderPatientNewFlowClinicalEdit
                                key={store.id}
                                facilityOrderPatientNewFlowClinicalEditViewStore={store}
                                disabled={disabled}
                                disabledSendOrder={disabledSendOrder}
                            />
                        ))
                        :
                        <React.Fragment></React.Fragment>
            }

            <BaasicConfirmModal modalParams={statusConfirmModal} />
            <BaasicConfirmModal modalParams={documentationRequestConfirmModal} />
            <BaasicConfirmModal modalParams={importConfirmModal} />
            <BaasicConfirmModal modalParams={importFacilityOrderConfirmModal} />

            <BaasicModal modalParams={facilityOrderNewFlowUSIntakeFindAndReplaceModal} className="modal__content modal--xlrg">
                <FacilityOrderNewFlowUSIntakeFindAndReplaceModal />
            </BaasicModal>
            <BaasicDraggableModal modalParams={facilityOrderTemplateItemNewFlowCalculationModal}>
                <FacilityOrderTemplateItemNewFlowCalculationModal />
            </BaasicDraggableModal>
             <BaasicModal modalParams={facilityOrderTemplateMissingDocumentNoteModal}>
                <FacilityOrderTemplateMissingDocumentNoteModal />
            </BaasicModal>
            <BaasicDraggableModal modalParams={facilityOrderTemplateNewFlowUSIntakePortalNoteModal} className="modal__content modal--med">
                <FacilityOrderTemplateNewFlowUSIntakePortalNoteModal />
            </BaasicDraggableModal>
            <BaasicDraggableModal modalParams={facilityOrderTemplateDoNotSupplyModal} className="modal__content modal--med">
                <FacilityOrderTemplateDoNotSupplyModal />
            </BaasicDraggableModal>
            <BaasicDraggableModal modalParams={facilityOrderTemplateNewFlowUSIntakeMissingProductNoteModal} className="modal__content modal--med">
                <FacilityOrderTemplateNewFlowUSIntakeMissingProductNoteModal />
            </BaasicDraggableModal>
            <BaasicModal modalParams={facilityOrderTemplateItemNewFlowDeleteQuestionModal} className="modal__content modal--med">
                <FacilityOrderTemplateItemNewFlowDeleteQuestionModal />
            </BaasicModal>
            <BaasicModal modalParams={facilityOrderTemplatePNMissingInformationModal} className="modal__content modal--med">
                <FacilityOrderTemplatePNMissingInformationModal />
            </BaasicModal>
            <BaasicModal modalParams={facilityOrderTemplateNewFlowUSIntakeTemplateActivationModal} className="modal__content modal--lrg">
                <FacilityOrderTemplateNewFlowUSIntakeTemplateActivationModal />
            </BaasicModal>
            <BaasicModal modalParams={facilityOrderTemplateNewFlowUSIntakeClinicalStatusNoteModal} className="modal__content modal--med">
                <FacilityOrderTemplateNewFlowUSIntakeClinicalStatusNoteModal />
            </BaasicModal>
            <BaasicModal modalParams={facilityOrderTemplateNewFlowDeleteModal} className="modal__content modal--med">
                <FacilityOrderTemplateNewFlowDeleteModal />
            </BaasicModal>
            <BaasicModal modalParams={facilityOrderTemplateNewFlowInsuranceHistoryOfChangesModal} className="modal__content modal--xxlrg">
                <FacilityOrderTemplateNewFlowInsuranceHistoryOfChangesModal />
            </BaasicModal>
            <BaasicDraggableModal modalParams={facilityOrderTemplateNewFlowUSIntakeInsuranceQuestionModal} className="modal__content modal--med">
                <FacilityOrderTemplateNewFlowUSIntakeInsuranceQuestionModal />
            </BaasicDraggableModal>
            <BaasicModal modalParams={facilityOrderPatientNewFlowInsuranceEditModal} className="modal__content modal--med">
                <FacilityOrderPatientNewFlowInsuranceEditModal />
            </BaasicModal>
            <BaasicDraggableModal modalParams={facilityOrderPatientNewFlowUSIntakeInsuranceInfoModal} className="modal__content modal--med">
                <FacilityOrderPatientNewFlowUSIntakeInsuranceInfoModal />
            </BaasicDraggableModal>
            <BaasicModal modalParams={facilityOrderPatientNewFlowInsuranceNoteModal} className="modal__content modal--med">
                <FacilityOrderPatientNewFlowInsuranceNoteModal />
            </BaasicModal>
            <BaasicModal modalParams={createFacilityOrderTemplateUSIntakeNewFlowModal} className="modal__content modal--xxlrg">
                <CreateFacilityOrderTemplateUSIntakeNewFlowModal />
            </BaasicModal>
            <BaasicModal modalParams={facilityOrderTemplateItemNewFlowActivatePatientModal}>
                <FacilityOrderTemplateItemNewFlowActivatePatientModal />
            </BaasicModal>
            <BaasicDraggableModal modalParams={facilityOrderPatientNewFlowUSIntakeEligibilityStatusNoteModal} className="modal__content modal--med">
                <FacilityOrderPatientNewFlowUSIntakeEligibilityStatusNoteModal />
            </BaasicDraggableModal> 
            <BaasicModal modalParams={facilityOrderTemplateNewFlowInvoiceNoteModal} className="modal__content modal--med">
                <FacilityOrderTemplateNewFlowInvoiceNoteModal />
            </BaasicModal>
            <BaasicConfirmModalNew modalParams={extraSuppliesApprovalRequiredModal} />
            <ScrollToTopButton />
        </PreviewLayout>
    )
}

FacilityOrderNewFlowClinicalPreviewTemplate.propTypes = {
    facilityOrderNewFlowClinicalPreviewViewStore: PropTypes.object.isRequired
};

export default defaultTemplate(FacilityOrderNewFlowClinicalPreviewTemplate);